const theme = {
    light: {
        primary: "#E4C590",
        secondery: "#202020",
        bg: "#0e0d0c",
        bgLight: "#171819",

        primaryTextColor: "#000",
        background: "#F2F2F2",
        black: "#333333",
        white: "#fff",
        border: "1px #fff solid",
        shadow: "2px 2px 7px 0 rgba(26,26,26,0.2)",
        hover: "",
        active: "",
        disabled: "",
        error: "",
        success: "",
        warning: "",
        heroTextColor: "#fff",



        titleFontFamily: "Forum, cursive",
        titleFontSize: "20px",
        head2FontSize: "48px",
        subTitleFontSize: "",
        fontFamily: "DM Sans, sans-serif",
        fontSize: "0.95rem",
        fontWeight: "400",
        lineHeight: "1.6",
        letterSpacing: ""
    }
}


export default theme;